module.exports = __webpack_public_path__ + "static/contact-8bc2a3c5822ca537327c65ab4d352679.svg";